import React, { useState, useEffect } from "react";
import Layout from "../../components/layout/Layout";
import "../../assets/InnerCSS/plugins/bootstrap/css/bootstrap.min.css";
import "../../assets/InnerCSS/plugins/font-awesome/css/font-awesome.min.css";
import "../../assets/InnerCSS/plugins/icomoon/style.css";
import "../../assets/InnerCSS/plugins/uniform/css/default.css";
import "../../assets/InnerCSS/plugins/switchery/switchery.min.css";
import "../../assets/InnerCSS/plugins/nvd3/nv.d3.min.css";
import "../../assets/InnerCSS/css/styles.css";
import "../../assets/InnerCSS/css/custom.css";
import InterviewerDashboardComponent from "../../components/interviewer/dashboard/InterviewerDashboardComponent";
import IdNameModel from "../../models/common/IdNameModel";
import masterDataService from "../../services/master-data-service";
import { ScreenEnum } from "../../models/enums/StatusEnum";
import toasterUtils from "../../utils/toaster-utils";
import { useHistory } from "react-router";

const InterviewerDashboard = () => {
    const history = useHistory();
    const [statusList, setStatusList] = useState<IdNameModel[]>([]);
    const [refreshStatus, setRefreshStatus] = useState<number>(2);
    useEffect(() => {
        getStatusList();
    }, []);

    const getStatusList = () => {
        setRefreshStatus(2);
        masterDataService.loadStatusByScreen(ScreenEnum.AddProfileStatus).then((res) => {
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            setStatusList(res.items);
            setRefreshStatus(refreshStatus * 5);
        }).catch((error) => {
            setRefreshStatus(refreshStatus * 5);
            toasterUtils.showError(error);
        });
    };

    return (
        <Layout>
             <div className="breadcrumb-text">
                <a onClick={() => history.push("/")}>Home</a> <i className="fa-solid fa-angle-right"></i> Dashboard
            </div>
            <div className="page-title">
                <h4 className="breadcrumb-header"> DASHBOARD</h4>
            </div>
            {refreshStatus > 2 &&
                <InterviewerDashboardComponent statusList={statusList} />
            }
        </Layout>
    );
};
export default InterviewerDashboard;